import * as types from './PlanOrderActionTypes';
import Api from '../PlanOrderApi';
import AnnotationApi from '../../../../planannotation/PlanAnnotationsApi';
import SharedApi from '../../../../../components/common/planOrder/SharedApi';
import { IDelivery } from '../Entities';
import { IPlanOrder } from '../agent/Entities';

export function resetState() {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        dispatch({ type: types.PLAN_ORDER_RESETSTATE });
}

function getPlanOrderSuccess(orders: any) {
    return { type: types.GET_PLAN_ORDER_SUCCESS, result: orders };
}

export function getPlanOrder(planOrderId: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.getPlanOrder(planOrderId).then((result: any) => {
            dispatch(getPlanOrderSuccess(result));
        });
}

function getAdminPlanOrderSuccess(orders: any) {
    return { type: types.GET_ADMIN_PLAN_ORDER_SUCCESS, result: orders };
}

export function getAdminPlanOrder(planOrderId: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.getAdminPlanOrder(planOrderId).then((result: any) => {
            dispatch(getAdminPlanOrderSuccess(result));
        });
}

function getCompareDataSuccess(result: any) {
    return { type: types.GET_ADMIN_PLAN_COMPARE_DATA_SUCCESS, result: result };
}

export function getCompareData(planOrderId: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        SharedApi.getCompareData(planOrderId).then((result: any) => {
            dispatch(getCompareDataSuccess(result));
        });
}
export function connectCubiCasaOrder(planOrderId: number, cubiCasaOrderId: string){
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.connectCubiCasaOrder(planOrderId, cubiCasaOrderId).then((result: any) => {
            dispatch(getConnectCubiCasaOrderSuccess(result));
        });
}
function getConnectCubiCasaOrderSuccess(result:any){
    return {
        type: types.CONNECT_CUBI_CASA_ORDER_SUCCESS,
        result: result
    }
}
export function manualSyncCubiCasaOrder(planOrderId:number,cubiCasaOrderId: string){
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.manualSyncCubiCasaOrder(planOrderId, cubiCasaOrderId).then((result: any) => {
            dispatch(getManualSyncCubiCasaOrder(result));
        });
}
function getManualSyncCubiCasaOrder(result:any){
    return {
        type: types.MANUAL_SYNC_CUBI_CASA_ORDER_SUCCESS,
        result: result
    }
}
function updatePlanOrderStoreySortSuccess(result: any) {
    return {
        type: types.UPDATE_PLAN_ORDER_STOREY_SORT_SUCCESS,
        result: result
    };
}

export function updatePlanOrderStoreySort(
    planOrderId: number,
    storey: { id: number; direction: 'up' | 'down' }
) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.updatePlanOrderStoreySort(planOrderId, storey).then((result: any) => {
            dispatch(updatePlanOrderStoreySortSuccess(result));
        });
}

function updateStartDateSuccess(date: any) {
    return { type: types.ADMIN_UPDATE_START_DATE_SUCCESS, result: date };
}

export function updateStartDate(planOrderId: number, date: any) {
    return (dispatch: (result: any) => void) =>
        Api.updateStartDate(planOrderId, date).then((result) => {
            dispatch(updateStartDateSuccess(result));
        });
}

function addStoreySuccess(storey: any) {
    return { type: types.ADD_STOREY_SUCCESS, result: storey };
}

export function addStorey(storey: any) {
    return (dispatch: (storey: any) => void, getState: (error: any) => void) =>
        dispatch(addStoreySuccess(storey));
}

export function createStorey(planOrderId: number, data: any) {
    return (dispatch: (storey: any) => void, getState: (error: any) => void) =>
        Api.createStorey(planOrderId, data).then((result) => {
            dispatch(addStoreySuccess(result));
            return result;
        });
}

function deleteStoreySuccess(result: any) {
    return { type: types.DELETE_STOREY_SUCCESS, result: result };
}

export function deleteStorey(planOrder: number, storeyId: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.deleteStorey(planOrder, storeyId).then((result: any) => {
            dispatch(deleteStoreySuccess(result));
        });
}

function sendPlanOrderSuccess(result: any) {
    return { type: types.SEND_PLAN_ORDER_SUCCESS, result: result };
}

export function sendPlanOrder(planOrderId: number, planOrder: any) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.sendPlanOrder(planOrderId, planOrder).then((result: any) => {
            dispatch(sendPlanOrderSuccess(result));
        });
}

function adminSendPlanOrderSuccess(result: any) {
    return { type: types.ADMIN_SEND_PLAN_ORDER_SUCCESS, result: result };
}

export function adminSendPlanOrder(planOrderId: number, planOrder: any) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.sendPlanOrder(planOrderId, planOrder).then((result: any) => {
            dispatch(adminSendPlanOrderSuccess(result));
        });
}

function savePlanOrderSuccess(result: any) {
    return { type: types.SAVE_PLAN_ORDER_SUCCESS, result: result };
}

export function savePlanOrder(planOrderId: number, planOrder: any) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.savePlanOrder(planOrderId, planOrder).then((result: any) => {
            dispatch(savePlanOrderSuccess(result));
        });
}

function updatePlanOrderSuccess(result: any) {
    return { type: types.UPDATE_PLAN_ORDER_SUCCESS, result: result };
}

export function updatePlanOrder(planOrderId: number, planOrderStoreyId: any, data: any) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.updateStorey(planOrderId, planOrderStoreyId, data).then((result: any) => {
            dispatch(updatePlanOrderSuccess(result));
        });
}

function editExternalFileAnnotationSucceeded(result: any): any {
    return {
        type: types.EDIT_EXTERNAL_FILE_ANNOTATION_SUCCESS,
        result: result
    };
}

export function editExternalFileAnnotation(fileId: number) {
    return (dispatch: any, getState: any) =>
        AnnotationApi.editExternalFileAnnotation(fileId).then((result: any) => {
            dispatch(editExternalFileAnnotationSucceeded(result));
        });
}

export function editDeliveryFileAnnotation(fileId: number) {
    return (dispatch: any, getState: any) =>
        AnnotationApi.editDeliveryFileAnnotation(fileId).then((result: any) => {
            dispatch(editExternalFileAnnotationSucceeded(result));
        });
}

function editAnnotationSucceeded(result: any): any {
    return { type: types.EDIT_PLAN_ANNOTATION_SUCCESS, result: result };
}

export function editAnnotation(planOrderStoreyFileId: number, planAnnotationType: string): any {
    return (dispatch: any, getState: any) =>
        AnnotationApi.editAnnotation(planOrderStoreyFileId, planAnnotationType).then(
            (result: any) => {
                dispatch(editAnnotationSucceeded(result));
                return result;
            }
        );
}

function saveAnnotationSucceeded(result: any): any {
    return { type: types.SAVE_PLAN_ANNOTATION_SUCCESS, result: result };
}

export function saveAnnotation(
    fileId: number,
    data: string,
    hasDoneCrop: boolean,
    revisionType: number,
    annotationType: string
): any {
    return (dispatch: any, getState: any) =>
        AnnotationApi.saveAnnotation(fileId, data, hasDoneCrop, revisionType, annotationType).then(
            (result: any) => {
                dispatch(saveAnnotationSucceeded(result));
                return result;
            }
        );
}

function updatePlanFirmSucceeded(planFirmId: any): any {
    return { type: types.UPDATE_PLAN_FIRM_SUCCESS, result: planFirmId };
}

export function updatePlanFirm(planOrderId: number, planFirmId: number): any {
    return (dispatch: any, getState: any) =>
        Api.updatePlanFirm(planOrderId, planFirmId).then((result: any) => {
            dispatch(updatePlanFirmSucceeded(planFirmId));
        });
}

function updatePlanEditorSucceeded(result: any): any {
    return { type: types.UPDATE_PLAN_EDITOR_SUCCESS, result: result };
}

export function updatePlanEditor(planOrderId: number, planEditorId: number): any {
    return (dispatch: any, getState: any) =>
        Api.updatePlanEditor(planOrderId, planEditorId).then((result: any) => {
            dispatch(updatePlanEditorSucceeded(result));
        });
}

function removePlanOrderRowSucceeded(result: any): any {
    return { type: types.REMOVE_PLAN_ORDER_ROW_SUCCESS, result: result };
}

export function removePlanOrderRow(planOrderId: number, orderRowId: number): any {
    return (dispatch: any, getState: any) =>
        Api.removePlanOrderRow(planOrderId, orderRowId).then((result: any) => {
            dispatch(removePlanOrderRowSucceeded(orderRowId));
        });
}

function addOrderRowSucceeded(result: any): any {
    return { type: types.ADD_ORDER_ROW_SUCCESS, result: result };
}

export function addOrderRow(planOrderId: number, productId: number): any {
    return (dispatch: any, getState: any) =>
        Api.addOrderRow(planOrderId, productId).then((result: any) => {
            dispatch(addOrderRowSucceeded(result));
        });
}

function sendToPlanFirmSucceeded(status: string): any {
    return { type: types.SEND_TO_PLAN_FIRM_SUCCESS, result: status };
}

export function sendToPlanFirm(planOrderId: number, data: any): any {
    return (dispatch: any, getState: any) =>
        Api.sendToPlanFirm(planOrderId, data).then((result: any) => {
            dispatch(sendToPlanFirmSucceeded(result));
        });
}

function deliverPlanOrderSucceeded(result: any): any {
    return { type: types.DELIVER_PLAN_ORDER_SUCCESS, result: result };
}

export function deliverPlanOrder(planOrderId: number, data: IDelivery) {
    return (dispatch: any) =>
        Api.deliverPlanOrder(planOrderId, data).then((result: any) => {
            dispatch(deliverPlanOrderSucceeded({ status: result, data: data }));
        });
}

function returnPlanOrderSucceeded(result: any): any {
    return { type: types.ADMIN_RETURN_PLAN_ORDER_SUCCESS, result: result };
}

export function returnPlanOrder(planOrderId: number, customerReturnedMessage: string) {
    return (dispatch: any) =>
        Api.returnPlanOrder(planOrderId, customerReturnedMessage).then((result: any) => {
            dispatch(returnPlanOrderSucceeded(result));
        });
}

function returnSketchUpPlanOrderSucceeded(result: any): any {
    return { type: types.RETURN_SKETCHUP_PLAN_ORDER_SUCCESS, result: result };
}

export function returnSketchUpPlanOrder(planOrderId: number) {
    return (dispatch: any) =>
        Api.returnSketchUpPlanOrder(planOrderId).then((result: any) => {
            dispatch(
                returnSketchUpPlanOrderSucceeded({
                    status: result.status,
                    planEditorId: result.planEditorId
                })
            );
        });
}

function returnRoomSketcherPlanOrderSucceeded(result: any): any {
    return {
        type: types.RETURN_ROOMSKETCHER_PLAN_ORDER_SUCCESS,
        result: result
    };
}

export function returnRoomSketcherPlanOrder(planOrderId: number) {
    return (dispatch: any) =>
        Api.returnRoomSketcherPlanOrder(planOrderId).then((result: any) => {
            dispatch(returnRoomSketcherPlanOrderSucceeded({ status: result }));
        });
}

function downloadFilesSuccess(result: any) {
    return { type: types.DOWNLOAD_FILES_PLAN_ORDER_SUCCESS, result: result };
}

export function downloadFiles(planOrderId: number, isAgent: boolean = false) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.downloadFiles(planOrderId, isAgent).then((result: any) => {
            dispatch(downloadFilesSuccess(result));
        });
}

function emailFilesSuccess(result: any) {
    return { type: types.EMAIL_FILES_PLAN_ORDER_SUCCESS, result: result };
}

export function emailFiles(planOrderId: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.emailFiles(planOrderId).then((result: any) => {
            dispatch(emailFilesSuccess(result));
        });
}

function updatePlacementsSuccess(result: any) {
    return { type: types.UPDATE_PLACEMENTS_SUCCESS, result: result };
}

export function updatePlacements(planOrderId: number, files: any[], planOrderStoreyFileId: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        AnnotationApi.updatePlacements(planOrderId, files, planOrderStoreyFileId).then(
            (result: any) => {
                dispatch(updatePlacementsSuccess(result));
                return result;
            }
        );
}

function approvePlanOrderSuccess(result: any) {
    return { type: types.APPROVE_PLAN_ORDER_ADMIN_SUCCESS, result: result };
}

export function approvePlanOrder(planOrderId: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.approvePlanOrder(planOrderId).then((result: any) => {
            dispatch(
                approvePlanOrderSuccess({
                    status: result.status,
                    storyDeliveryFiles: result.storyDeliveryFiles,
                    planOrderId: planOrderId
                })
            );
        });
}

function generateFilesSuccess(result: any) {
    return {
        type: types.GENERATE_FILES_PLAN_ORDER_ADMIN_SUCCESS,
        result: result
    };
}

export function generateFiles(planOrderId: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.generateFiles(planOrderId).then((result: any) => {
            dispatch(generateFilesSuccess(result));
            return result;
        });
}

function addPlanOrderInternalExternalFileSuccess(result: any) {
    return {
        type: types.ADMIN_ADD_PLAN_ORDER_INTERNAL_EXTERNAL_FILE_SUCCESS,
        result: result
    };
}

export function addPlanOrderInternalExternalFile(
    id: number,
    planOrderId: number,
    fileInfoId: number,
    filename: string,
    fileReference: string,
    fileType: string,
    thumbnailReference: string,
    oldFileId?: number
) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) => {
        dispatch(
            addPlanOrderInternalExternalFileSuccess({
                id: id,
                planOrderId: planOrderId,
                fileInfoId: fileInfoId,
                filename: filename,
                fileReference: fileReference,
                fileType: fileType,
                thumbnailReference: thumbnailReference,
                oldFileId: oldFileId
            })
        );
    };
}

function addPlanOrderExternalDeliveryFileSuccess(result: any) {
    return {
        type: types.ADMIN_ADD_PLAN_ORDER_EXTERNAL_DELIVERY_FILE_SUCCESS,
        result: result
    };
}

export function addPlanOrderExternalDeliveryFile(
    id: number,
    planOrderId: number,
    fileInfoId: number,
    filename: string,
    fileReference: string,
    fileType: string,
    thumbnailReference: string,
    oldFileId?: number
) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) => {
        dispatch(
            addPlanOrderExternalDeliveryFileSuccess({
                id: id,
                planOrderId: planOrderId,
                fileInfoId: fileInfoId,
                filename: filename,
                fileReference: fileReference,
                fileType: fileType,
                thumbnailReference: thumbnailReference,
                oldFileId: oldFileId
            })
        );
    };
}

function deletePlanOrderInternalExternalFileSuccess(result: any) {
    return {
        type: types.ADMIN_DELETE_PLAN_ORDER_INTERNAL_EXTERNAL_FILE_SUCCESS,
        result: result
    };
}

export function deletePlanOrderInternalExternalFile(planOrderId: number, fileInfoId: number) {
    return (dispatch: (result: any) => void) =>
        Api.deletePlanOrderExternalFile(planOrderId, fileInfoId).then((result: any) => {
            dispatch(deletePlanOrderInternalExternalFileSuccess(result));
        });
}

function deletePlanOrderExternalDeliveryFileSuccess(result: any) {
    return {
        type: types.ADMIN_DELETE_PLAN_ORDER_EXTERNAL_DELIVERY_FILE_SUCCESS,
        result: result
    };
}

export function deletePlanOrderExternalDeliveryFile(planOrderId: number, fileInfoId: number) {
    return (dispatch: (result: any) => void) =>
        Api.deletePlanOrderExternalFile(planOrderId, fileInfoId).then((result: any) => {
            dispatch(deletePlanOrderExternalDeliveryFileSuccess(result));
        });
}

function addPlanOrderStoreyExternalFileSuccess(result: any) {
    return {
        type: types.ADMIN_ADD_PLAN_ORDER_STOREY_EXTERNAL_FILE_SUCCESS,
        result: result
    };
}

export function addPlanOrderStoreyExternalFile(
    planOrderStoreyId: number,
    fileInfoId: number,
    filename: string,
    fileReference: string,
    fileType: string,
    thumbnailReference: string,
    oldFileInfoId?: number,
    oldFileReference?: string
) {
    return (dispatch: (result: any) => void) => {
        dispatch(
            addPlanOrderStoreyExternalFileSuccess({
                planOrderStoreyId: planOrderStoreyId,
                fileInfoId: fileInfoId,
                filename: filename,
                fileReference: fileReference,
                fileType: fileType,
                thumbnailReference: thumbnailReference,
                oldFileInfoId: oldFileInfoId,
                oldFileReference: oldFileReference
            })
        );
    };
}

function deletePlanOrderStoreyExternalFileSuccess(result: any) {
    return {
        type: types.ADMIN_DELETE_PLAN_ORDER_STOREY_EXTERNAL_FILE_SUCCESS,
        result: result
    };
}

export function deletePlanOrderStoreyExternalFile(
    planOrderId: number,
    planOrderStoreyId: number,
    fileInfoId: number
) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.deletePlanOrderStoreyExternalFile(planOrderId, planOrderStoreyId, fileInfoId).then(
            (result: any) => {
                dispatch(deletePlanOrderStoreyExternalFileSuccess(result));
            }
        );
}

function addPlanOrderStoreyBlueprintFileSuccess(result: any) {
    return {
        type: types.ADD_PLAN_ORDER_STOREY_BLUEPRINT_FILE_SUCCESS,
        result: result
    };
}

export function addPlanOrderStoreyBlueprintFile(planOrderStoreyId: number, result: any) {
    return (dispatch: (result: any) => void) => {
        dispatch(
            addPlanOrderStoreyBlueprintFileSuccess({
                planOrderStoreyId: planOrderStoreyId,
                file: result
            })
        );
    };
}

function addPlanOrderStoreySketchUp2DFileSuccess(result: any) {
    return {
        type: types.ADD_PLAN_ORDER_STOREY_SKETCHUP_2D_FILE_SUCCESS,
        result: result
    };
}

export function addPlanOrderStoreySketchUp2DFile(planOrderStoreyId: number, result: any) {
    return (dispatch: (result: any) => void) => {
        dispatch(
            addPlanOrderStoreySketchUp2DFileSuccess({
                planOrderStoreyId: planOrderStoreyId,
                file: result
            })
        );
    };
}

function addPlanOrderStoreySketchUp3DFileSuccess(result: any) {
    return {
        type: types.ADD_PLAN_ORDER_STOREY_SKETCHUP_3D_FILE_SUCCESS,
        result: result
    };
}

export function addPlanOrderStoreySketchUp3DFile(planOrderStoreyId: number, result: any) {
    return (dispatch: (result: any) => void) => {
        dispatch(
            addPlanOrderStoreySketchUp3DFileSuccess({
                planOrderStoreyId: planOrderStoreyId,
                file: result
            })
        );
    };
}

function addPlanOrderStoreyRoomSketcher2DFileSuccess(result: any) {
    return {
        type: types.ADD_PLAN_ORDER_STOREY_ROOMSKETCHER_2D_FILE_SUCCESS,
        result: result
    };
}

export function addPlanOrderStoreyRoomSketcher2DFile(planOrderStoreyId: number, result: any) {
    return (dispatch: (result: any) => void) => {
        dispatch(
            addPlanOrderStoreyRoomSketcher2DFileSuccess({
                planOrderStoreyId: planOrderStoreyId,
                file: result
            })
        );
    };
}

function addPlanOrderStoreyRoomSketcher3DFileSuccess(result: any) {
    return {
        type: types.ADD_PLAN_ORDER_STOREY_ROOMSKETCHER_3D_FILE_SUCCESS,
        result: result
    };
}

export function addPlanOrderStoreyRoomSketcher3DFile(planOrderStoreyId: number, result: any) {
    return (dispatch: (result: any) => void) => {
        dispatch(
            addPlanOrderStoreyRoomSketcher3DFileSuccess({
                planOrderStoreyId: planOrderStoreyId,
                file: result
            })
        );
    };
}

function toggleTemplateGenerationSuccess(active: boolean) {
    return {
        type: types.PLAN_ORDER_TOGGLE_TEMPLATE_GENERATION_SUCCESS,
        result: active
    };
}

export function toggleTemplateGeneration(planOrderId: number) {
    return (dispatch: (result: any) => void) =>
        Api.toggleTemplateGeneration(planOrderId).then((result: any) => {
            dispatch(toggleTemplateGenerationSuccess(result));
        });
}

export function resetDelivery(orderId: number) {
    return (dispatch: (result: any) => void) => Api.resetDelivery(orderId);
}

export function stopDelivery(orderId: number) {
    return (dispatch: (result: any) => void) => Api.stopDelivery(orderId);
}

export function createEmptyStorey(planOrderId: number) {
    return (dispatch: (result: any) => void) =>
        Api.createEmptyStorey(planOrderId).then((result: any) => {
            dispatch(addStoreySuccess(result));
        });
}

function adminGrabSuccess(result: any) {
    return { type: types.PLAN_ORDER_ADMIN_GRAB_SUCCESS, result: result };
}

export function adminGrab(planOrderId: number) {
    return (dispatch: (result: any) => void) =>
        Api.adminGrab(planOrderId).then((result: any) => {
            dispatch(adminGrabSuccess({ status: result }));
        });
}

function hideDeliveryFailureSuccess(result: any): any {
    return { type: types.HIDE_DELIVERY_FAILURE, result: result };
}

export function hideDeliveryFailure(
    planOrderId: number,
    sketchUpStatus: number,
    roomSketcherStatus: number
) {
    return (dispatch: (result: any) => void) =>
        Api.hideDeliveryFailure(planOrderId).then((result: any) => {
            dispatch(hideDeliveryFailureSuccess(result));
        });
}

function returnToBrokerSuccess(result: any): any {
    return { type: types.RETURN_TO_BROKER, result: result };
}

export function returnToBroker(planOrderId: number) {
    return (dispatch: (result: any) => void) =>
        Api.returnToBroker(planOrderId).then((result: any) => {
            dispatch(returnToBrokerSuccess(result));
        });
}

function sketchupStatusSetSuccessfully(newStatus: { id: number; name: string }) {
    return { type: types.SKETCHUP_STATUS_SET_SUCCESSFULLY, result: newStatus };
}

export function setSketchupStatus(planOrderId: number, newStatus: number) {
    return (dispatch: (result: any) => void) =>
        Api.setSketchupStatus(planOrderId, newStatus).then(
            (result: { id: number; name: string }) => {
                dispatch(sketchupStatusSetSuccessfully(result));
            }
        );
}

function roomsketcherStatusSetSuccessfully(newStatus: { id: number; name: string }) {
    return {
        type: types.ROOMSKETCHER_STATUS_SET_SUCCESSFULLY,
        result: newStatus
    };
}

export function setRoomsketcherStatus(planOrderId: number, newStatus: number) {
    return (dispatch: (result: any) => void) =>
        Api.setRoomsketcherStatus(planOrderId, newStatus).then(
            (result: { id: number; name: string }) => {
                dispatch(roomsketcherStatusSetSuccessfully(result));
            }
        );
}
export function email(planOrderId: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.email(planOrderId);
}

function deleteDeliveryFileSuccess(result: any) {
    return { type: types.ADMIN_DELETE_DELIVERY_FILE_SUCCESS, result: result };
}

export function deleteDeliveryFile(reference: string) {
    return (dispatch: (result: any) => void) =>
        Api.deleteDeliveryFile(reference).then((result: any) => {
            dispatch(deleteDeliveryFileSuccess(reference));
        });
}

function inActivateExternalFileSuccess(planOrderExternalFileId: number) {
    return {
        type: types.INACTIVATE_EXTERNAL_FILE_SUCCESS,
        result: planOrderExternalFileId
    };
}

export function inActivateExternalFile(planOrderExternalFileId: number) {
    return (dispatch: (result: any) => void) =>
        Api.inActivateExternalFile(planOrderExternalFileId).then((result: any) => {
            dispatch(inActivateExternalFileSuccess(planOrderExternalFileId));
        });
}

function resetScheduledDeliverySuccess(result: any) {
    return {
        type: types.ADMIN_RESET_SCHEDULED_PLAN_ORDER_DELIVERY_SUCCESS,
        result: result
    };
}

export function resetScheduledDelivery(planOrderId: number) {
    return (dispatch: (result: any) => void) =>
        Api.resetScheduledDelivery(planOrderId).then((result: any) => {
            dispatch(resetScheduledDeliverySuccess(result));
        });
}

function setPlanOrderSuccess(planOrder: IPlanOrder) {
    return { type: types.SET_PLAN_ORDER_SUCCESS, result: planOrder };
}

export function setPlanOrder(planOrder: IPlanOrder) {
    return (dispatch: (result: any) => void) => dispatch(setPlanOrderSuccess(planOrder));
}

function resetPlanOrderArchiveStateSuccess(result: any) {
    return {
        type: types.RESET_PLAN_ORDER_ARCHIVE_STATE_SUCCESS,
        result: result
    };
}

export function resetPlanOrderArchiveState(planOrderId: number) {
    return (dispatch: (result: any) => void) =>
        Api.resetPlanOrderArchiveState(planOrderId).then((result: any) => {
            dispatch(resetPlanOrderArchiveStateSuccess(result));
        });
}

function returnCubiCasaOrderSuccess(result: any) {
    return {
        type: types.RETURN_CUBI_CASA_ORDER_SUCCESS,
        result: result
    };
}

export function returnCubiCasaOrder(planOrderId: number) {
    return (dispatch: (result: any) => void) =>
        Api.returnCubiCasaOrder(planOrderId).then((result: any) => {
            dispatch(returnCubiCasaOrderSuccess(result));
        });
}

function deleteCubiCasaOrderSuccess(result: any) {
    return {
        type: types.DELETE_CUBI_CASA_ORDER_SUCCESS,
        result: result
    };
}

export function deleteCubiCasaOrder(planOrderId: number) {
    return (dispatch: (result: any) => void) =>
        Api.deleteCubiCasaOrder(planOrderId).then((result: any) => {
            dispatch(deleteCubiCasaOrderSuccess(result));
        });
}
